var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import { min, max } from "d3-array";
import { scaleLinear, scaleBand } from "d3-scale";
import Chart from "../Chart/Chart.esm.js";
import XAxis from "../Chart/XAxis.esm.js";
import YAxis from "../Chart/YAxis.esm.js";
import DataSeries from "./DataSeries.esm.js";
import { getWholeDollars } from "../../../utils/zhl-calculator.esm.js";
class BarChart extends Component {
  render() {
    const {
      data,
      margins,
      width,
      height,
      legend,
      colors,
      axesColor,
      xAxisFormatter,
      tickTextStroke
    } = this.props;
    const values = data.map((item) => item.value), labels = data.map((item) => item.label), sideMargins = margins.left + margins.right, topBottomMargins = margins.top + margins.bottom, minValue = Math.min(min(values), 0), xScale = scaleLinear().domain([minValue, max(values)]).range([0, width - sideMargins]), yScale = scaleBand().domain(labels).rangeRound([margins.top, height - margins.bottom]);
    const trans = `translate(${margins.left},${margins.top})`, xAxisTickCount = Math.floor(width / 60);
    return /* @__PURE__ */ jsx(Chart, { legend, data, margins, colors, width, height, children: /* @__PURE__ */ jsxs("g", { transform: trans, className: "rd3-barchart", children: [
      /* @__PURE__ */ jsx(DataSeries, { yScale, xScale, margins, data, width: width - sideMargins, height: height - topBottomMargins }),
      /* @__PURE__ */ jsx(YAxis, { yAxisClassName: "rd3-barchart-yaxis", yScale, margins, width: width - sideMargins, height: height - topBottomMargins, tickTextStroke, tickStroke: axesColor, stroke: axesColor }),
      /* @__PURE__ */ jsx(XAxis, { xAxisClassName: "rd3-barchart-xaxis", xScale, margins, xAxisTickCount, tickFormatting: xAxisFormatter, width: width - sideMargins, height: height - topBottomMargins, tickTextStroke, tickStroke: axesColor, stroke: axesColor })
    ] }) });
  }
}
__publicField(BarChart, "propTypes", {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array,
  width: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  margins: PropTypes.object,
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  title: PropTypes.string,
  xAxisFormatter: PropTypes.func,
  axesColor: PropTypes.string,
  tickTextStroke: PropTypes.string,
  // Simply to satisfy eslint
  // eslint-disable-next-line zillow/react/forbid-prop-types
  legend: PropTypes.any,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  colors: PropTypes.any
});
__publicField(BarChart, "defaultProps", {
  margins: {
    top: 10,
    right: 20,
    bottom: 40,
    left: 50
  },
  xAxisFormatter: (input) => getWholeDollars(input)
});
export {
  BarChart as default
};
